import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { ProductBundleResponse } from '../models/product-bundle.model';
import { DrawerRegistryService } from '../../../shared/services/drawer-registry.service';

export interface ProductBundleDrawerOptions {
  productBundleId?: number;
}

@Injectable({ providedIn: 'root' })
export class ProductBundleDrawerService {
  private readonly registry = inject(DrawerRegistryService);
  private readonly state$ = new BehaviorSubject<{ isOpen: boolean; options: ProductBundleDrawerOptions }>({
    isOpen: false,
    options: {}
  });

  private readonly bundleSaved$$ = new Subject<ProductBundleResponse>();

  readonly state = this.state$.asObservable();
  readonly bundleSaved$ = this.bundleSaved$$.asObservable();

  open(options: ProductBundleDrawerOptions = {}): void {
    if (!this.state$.value.isOpen) this.registry.opened();
    this.state$.next({ isOpen: true, options });
  }

  close(): void {
    if (this.state$.value.isOpen) this.registry.closed();
    this.state$.next({ isOpen: false, options: {} });
  }

  notifySaved(bundle: ProductBundleResponse): void {
    this.bundleSaved$$.next(bundle);
  }
}
